export default "__VITE_ASSET__SSVS9hS2__"